import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProsiebenComponent } from './simple-icons-prosieben.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProsiebenComponent ],
    exports:      [ SimpleIconsProsiebenComponent ],
    bootstrap:    []
})
export class SimpleIconsProsiebenModule {}
